import React, { useState, useEffect, SyntheticEvent } from 'react';

import {
  readCookie,
  setPrivacyCookie,
  readOnetrustSettings
} from '../../../../utils/analytics/onetrust';
import { trackWithFingerprint } from '../../../../utils/trackWithFingerprint';

import { Flexbox, FlexboxProps } from '../../../Flexbox';
import { ConsentModal } from '../../../ConsentModal';

import {
  FooterLegalNavItemList,
  SecondaryNavItem,
  SecondaryLink
} from './styles';
import { ILink, ILinkFields } from '../../../../../types/contentful';

interface LegalNavLinksProps extends FlexboxProps {
  isAffiliateFooter?: boolean;
  links?: ILink[];
}

export function LegalNavLinks({
  isAffiliateFooter,
  links,
  ...props
}: LegalNavLinksProps) {
  const COOKIE_NAME = 'OptanonConsent';
  const [isConsentModalOpen, setIsConsentModalOpen] = useState(false);
  const [optedOut, setOptedOut] = useState<boolean>(false);

  useEffect(() => {
    // On load, default to true if cookie does not exist
    const privacyCookie = readCookie(COOKIE_NAME);

    if (privacyCookie.trim() === '') {
      setPrivacyCookie(true);
    }

    const settings = readOnetrustSettings();
    // C0004 is the key for targeting, this should be enough to control the toggle
    setOptedOut(settings?.C0004 === false);
  }, []);

  const toggleOptOutModal = () => {
    if (isConsentModalOpen === false) {
      document.body.style.overflowY = 'hidden';
    } else {
      document.body.style.overflowY = '';
    }

    setIsConsentModalOpen(!isConsentModalOpen);
  };

  return (
    <Flexbox {...props} data-testid="legal-nav-list">
      <FooterLegalNavItemList>
        {links &&
          links.map(({ sys, fields }) => {
            const { title, url, openInNewTab, hasAffiliateLink }: ILinkFields =
              fields;
            const path = url ?? '';

            return title?.toLowerCase().includes('do not sell') ? (
              <SecondaryNavItem
                data-testid="privacy-modal-link"
                key={sys?.id || title}
              >
                <SecondaryLink
                  href="#"
                  onClick={(e: SyntheticEvent) => {
                    e.preventDefault();
                    trackWithFingerprint('Do Not Sell Selected', {
                      opted_out: optedOut
                    });
                    toggleOptOutModal();
                  }}
                >
                  {title}
                </SecondaryLink>
              </SecondaryNavItem>
            ) : (
              <SecondaryNavItem key={sys?.id || title}>
                <SecondaryLink
                  href={
                    isAffiliateFooter && hasAffiliateLink
                      ? `/affiliates${path}`
                      : path
                  }
                  target={openInNewTab ? '_blank' : ''}
                  rel="noopener noreferrer"
                >
                  {title}
                </SecondaryLink>
              </SecondaryNavItem>
            );
          })}
      </FooterLegalNavItemList>
      {isConsentModalOpen && (
        <ConsentModal
          optedOut={optedOut}
          setOptedOut={setOptedOut}
          toggleOptOutModal={toggleOptOutModal}
        />
      )}
    </Flexbox>
  );
}
